module.exports = __webpack_public_path__ + "static/img/supertechauto.25064ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/supertechauto.png
// module id = g+3l
// module chunks = 0